// extracted by mini-css-extract-plugin
module.exports = {"Disclaimers":"Disclaimers_Disclaimers__1Q46-","DisclaimersImage":"Disclaimers_DisclaimersImage__1pi9O","LinkParagraph5Content3":"Disclaimers_LinkParagraph5Content3__4e5pA"};